import type { IntlShape } from 'react-intl/src/types';

import type { FeatureProps } from '@/components/KeyFeatures/components/Features/Feature';
import type {
  StrapAttributesFragment,
  StrapBuckleSizesQuery,
} from '@/graphql/saleor/api';
import { getDropdownValue, resolveColor } from '@/lib/attributes';
import type { Maybe } from '@/lib/types';

import buckleSizeSvg from '@/assets/buckle-size.svg';
import buckleTypeSvg from '@/assets/buckle-type.svg';
import colorSvg from '@/assets/color.svg';
import lugSvg from '@/assets/lug.svg';
import lugTypeSVG from '@/assets/lug-type.svg';
import materialSvg from '@/assets/material.svg';

import { plpKeyFeaturesMessages } from './messages';
export const getKeyFeatures = (
  attributes: StrapAttributesFragment,
  buckleSize: Maybe<string>,
  formatMessage: IntlShape['formatMessage'],
): FeatureProps[] => {
  const features = [
    {
      name: formatMessage(plpKeyFeaturesMessages.material),
      value: getDropdownValue(attributes.strapMaterial),
      icon: {
        alt: 'Material',
        src: materialSvg,
      },
    },
    {
      name: formatMessage(plpKeyFeaturesMessages.color),
      value: resolveColor(attributes.color).cssValue,
      displayName: resolveColor(attributes.color).displayName,
      icon: {
        alt: 'Color',
        src: colorSvg,
      },
    },
    {
      name: formatMessage(plpKeyFeaturesMessages.lugType),
      value: getDropdownValue(attributes.lugType),
      icon: {
        alt: 'Lug type',
        src: lugTypeSVG,
      },
    },
    {
      name: formatMessage(plpKeyFeaturesMessages.lug),
      value: getDropdownValue(attributes.lug),
      icon: {
        alt: 'Lug',
        src: lugSvg,
      },
    },
    {
      name: formatMessage(plpKeyFeaturesMessages.buckleType),
      value: getDropdownValue(attributes.buckleType),
      icon: {
        alt: 'Buckle type',
        src: buckleTypeSvg,
      },
    },
  ];
  buckleSize &&
    features.push({
      name: formatMessage(plpKeyFeaturesMessages.buckleSize),
      value: buckleSize,
      icon: {
        alt: 'Buckle size',
        src: buckleSizeSvg,
      },
    });
  return features;
};

export const getBuckleSize = (data: StrapBuckleSizesQuery) => {
  const foundBuckleSizes = data.products?.edges.map(
    (edge) => edge.node.size?.values[0]?.name,
  );

  return foundBuckleSizes?.find((size) => !!size);
};
